import { cn } from '@/utils'

interface GuideProgressProps {
  stepKeys: string[]
  stepIndex: number
}

export const GuideProgress = ({ stepKeys, stepIndex }: GuideProgressProps) => (
  <div className="flex items-center gap-3">
    <div aria-hidden className="flex items-center gap-1.5">
      {stepKeys.map((key, position) => (
        <span
          key={key}
          className={cn(
            'h-1.5 rounded-full transition-all duration-300',
            position === stepIndex ? 'w-8 bg-brand' : 'w-3',
            position < stepIndex && 'bg-brand/40',
            position > stepIndex && 'bg-blue-2',
          )}
        />
      ))}
    </div>
    <span className="text-xs font-medium text-brand-deep">
      Step {stepIndex + 1} of {stepKeys.length}
    </span>
  </div>
)
